
const App = {

  model: {

    auth: {

      identity: [
        {
          slug: 'login',
          Page: 'LoginPage',
        },
        {
          slug: 'accept-invite',
          Page: 'AcceptInvitePage',
        },
        {
          slug: 'forgot-password',
          Page: 'ForgotPasswordPage',
        },
        {
          slug: 'reset-password',
          Page: 'ResetPasswordPage',
        },
        {
          slug: 'bootstrap-admin',
          Page: 'BootstrapAdminPage',
        },
      ],

      settings: {
        section: 'settings',
        Page: 'SettingsPage',

        label: 'Account',
        path: '/settings',

        title: 'Account',
        subtitle: 'Manage your account and workspace preferences.',
      },

      users: {
        section: 'users',
        Page: 'UsersPage',

        label: 'Users',
        path: '/users',

        title: 'Users',
        subtitle: 'Admin tools for workspace access and roles.',
      },

    },

    modules: {

      handle: {
        section: 'dashboard',
        Page: 'DashboardPage',
        Icon: 'DashboardIcon',

        title: "Dashboard",
        subtitle: "Welcome back, here&rsquo;s what&rsquo;s happening in your Strategy Workspace.",
      },

      identity: [
        {
          section: 'insights',
          Page: 'InsightsPage',
          Icon: 'InsightsIcon',

          title: "Insights",
          subtitle: "Decision support based on current planning, execution, deadlines, and activity signals.",
        },

        {
          section: 'reporting',
          Page: 'ReportingPage',
          Icon: 'ReportsIcon',

          title: "Reporting",
          subtitle: "Operational reporting for strategy coverage, execution cadence, and deadline watchlists.",
        },

        {
          section: 'capacity',
          Page: 'CapacityPage',
          Icon: 'InsightsIcon',

          title: "Capacity",
          subtitle: "Workload by person and position, aligned to organizations and strategies.",
        },

        {
          section: 'dashboards',
          Page: 'DashboardsPage',
          Icon: 'ReportsIcon',

          title: "Dashboards",
          subtitle: "Composable views of reports, health and recent workspace activity.",
        },

        {
          section: 'cadences',
          Page: 'CadencesPage',
          Icon: 'ReportsIcon',

          title: "Review cadence",
          subtitle: "Scheduled packets of due work, health drift and recent changes.",
        },

        {
          section: 'scenarios',
          Page: 'ScenariosPage',
          Icon: 'InsightsIcon',

          title: "Scenarios",
          subtitle: "Draft plan changes, preview health and forecast impact, then merge.",
        },

        {
          section: 'automation',
          Page: 'AutomationPage',
          Icon: 'DashboardIcon',

          title: "Automation",
          subtitle: "Rule activity, test-runs and the roles rules act with.",
        },

        {
          section: 'link-health',
          Page: 'LinkHealthPage',
          Icon: 'ReportsIcon',

          title: "Link health",
          subtitle: "Parent link parity, repair and the switch to link-based hierarchy reads.",
        },
      ],

      domain: [
        {
          slug: 'idioms',
          section: 'Idiom',
          handle: 'slug'
        },
        {
          slug: 'models',
          section: 'Model',
          handle: 'id'
        },
      ]

    }

  },

  Meta: {
    
    Identity: require( './meta/identity' ).default,

    Domain: require( './meta/domain' ).default,

  },

  Data: {

    Identity: require( './data/identity' ).default,

    Domain: require( './data/domain' ).default

  },

};

export default App;
